// extracted by mini-css-extract-plugin
export default {"app":"App_app__kZzsH","board":"App_board__7iRMD","popup":"App_popup__Nnq5+"};